import { EventEmitter } from '@angular/core';
var BorradorStorageService = /** @class */ (function () {
    function BorradorStorageService() {
        this.changed = false;
        this.change = new EventEmitter();
    }
    BorradorStorageService.prototype.cambioStorage = function () {
        this.changed = !this.changed;
        this.change.emit(this.changed);
        console.log('cambio en storage');
    };
    return BorradorStorageService;
}());
export { BorradorStorageService };
